import Keycloak from 'keycloak-js';

const keycloakConfig = {
    url: process.env.VUE_APP_KEYCLOAK_AUTH,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT,
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
